import chantalVideo from "./chantal-video.mp4";

export default chantalVideo;
